import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Input from '@material-ui/core/Input';
import classNames from "classnames";
import { Grid } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typography from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import 'react-phone-input-2/lib/style.css'
import SocialComponent from '../../components/SocialComponent';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import countries from '../../../countries';
import { domainName } from '../../../portal.config';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const SuccessIcon = portalCfg.publicPath + "/icons/check.png";



const styles = theme => ({
    container: {
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin: {
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        padding: theme.spacing(5, 5, 5, 5),
    },
});
function LoginView(props){
    const { classes, t, language, showAlert, onShowLoading } = props;
    return(
        <PublicPage rightComponent={<LoginViewComponent classes={classes}
            t={t}
            onSendOTP={props.onSendOTP}
            showAlert={showAlert}
            onShowLoading={onShowLoading}
            country_select={props.country_select}
            onSelectCountry={props.onSelectCountry}
            onRegister = {props.onRegister}
            agreement_countries={props.agreement_countries} 
            auth_support={props.auth_support}
            />} />
    )
}

function LoginViewComponent(props) {
    const { classes, t, showAlert, onShowLoading, auth_support } = props;
    return (
        <Grid xs={12} sm={12} md={12} item container>
            <Grid xs={12} sm={12} item container>
                <Typography variant='h2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} mg_bottom_md>{t('btn_login')}</Typography>
            </Grid>
            <Grid xs={12} item container direction="row">
                <Typography variant='body2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} center>{t('dont_have_account')}&nbsp;</Typography>
                <LinkRouter type='body2' size='sm' color='primary' onClick = {props.onRegister}>{t('btn_register')} </LinkRouter>
            </Grid>
            
            <Grid xs={12} sm={12} item container justify='center' className={classes.marginTop}>
                <LoginForm classes={classes} t={t}
                    onSubmit={props.onSendOTP}
                    country_select={props.country_select}
                    onSelectCountry={props.onSelectCountry}
                    agreement_countries={props.agreement_countries} 
                />
            </Grid>
            {(auth_support.facebook || auth_support.google)?<SocialComponent showAlert={showAlert} onShowLoading={onShowLoading} auth_support={auth_support} /> : null}
        </Grid>

    )
}
function LoginForm(props) {
    const { classes, t, showAlert, onShowLoading } = props;
    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item>
                    <Field
                        name="phone"
                        component={TextFieldWithSelectComponent}
                        label={t('phone_number')}
                        isEdit={true}
                        validate={validators.composeValidators(validators.mustBeNumber)}
                        autoFocus={true}
                        selectData={countries}
                        defaultValueSelect={props.country_select}
                        valueSelect={props.country_select}
                        onSelectedChange={props.onSelectCountry}
                    />
                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <Button color='primary' fullWidth onClick={handleSubmit}>{t('btn_login')}</Button>
                    </Grid>
                </Grid>
            )} />
    )
}
export default withStyles(styles)(withTranslation()(LoginView));